import React from "react";
import { Link } from "react-router-dom";
import routes from "../../routes";
import styles from "./Footer.module.scss";
import spinLogo from "../../static/icons/spin-v2.svg";
import twitterIcon from "../../static/icons/twitter.svg";
import linkedinIcon from "../../static/icons/linkedin.svg";
import instagramIcon from "../../static/icons/instagram.svg";
import tiktokIcon from "../../static/icons/tiktok.svg";

const Footer = ({ className, flushBottom = false }) => {
  return (
    <div className={`${styles.footerContainer} ${flushBottom ? styles.flushBottom : ""} ${className}`}>
      <div className={styles.footerContent}>
        <div className={styles.logoSection}>
          <div className={styles.logo}>
            <img src={spinLogo} alt="Spin Logo" />
          </div>
        </div>
        <div className={styles.infoSection}>
          <div className={styles.companyInfo}>
            Smart Products Infrastructure Network, Inc.<br/>
            1111B South Governors Ave STE 25387<br/>
            Dover, Delaware - DE 19904 US
          </div>
          <div className={styles.linksSection}>
            {/* Desktop links */}
            <div className={styles.links}>
              <Link to={routes.termsBusiness}>Business T&C</Link><br/>
              <Link to={routes.termsUsers}>User T&C</Link><br/>
              <Link to={routes.termsPrivacy}>Privacy T&C</Link><br/>
              <Link to={routes.termsCookies}>Cookies T&C</Link>
            </div>
            {/* Mobile links (only visible on mobile via CSS) */}
            <div className={styles.linksMobile}>
              <Link to={routes.subscription}>Subscription Plans</Link>
              <Link to={routes.os}>SPIN OS</Link>
              <Link to={routes.store}>IoT Store</Link>
              <Link to={routes.termsBusiness}>Business T&C</Link>
              <Link to={routes.termsUsers}>User T&C</Link>
              <Link to={routes.termsPrivacy}>Privacy T&C</Link>
              <Link to={routes.termsCookies}>Cookies T&C</Link>
            </div>
            <div className={styles.socialmediallogs}>
              {/* Desktop icons (images) */}
              <div className={styles.socialMediaRow}>
                <div className={styles.socialIcon}>
                  <img src={twitterIcon} width={21} height={21} alt="Twitter" />
                </div>
                <div className={styles.socialIcon}>
                  <img src={linkedinIcon} width={21} height={21} alt="LinkedIn" />
                </div>
                <div className={styles.socialIcon}>
                  <img src={instagramIcon} width={21} height={21} alt="Instagram" />
                </div>
                <div className={styles.socialIcon}>
                  <img src={tiktokIcon} width={21} height={21} alt="TikTok" />
                </div>
              </div>
              {/* Mobile-only inline SVG icons (2x2) */}
              <div className={styles.socialMediaRowMobile} aria-hidden>
                {/* X (Twitter) */}
                <div className={styles.socialIcon}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8.69629 6.02148L8.40039 5.62695L12.957 0.5H15.2354L9.54492 7.13867L15.9004 15.5H11.582L7.2041 9.83008L2.40039 15.5H0L6.04785 8.33301L0 0.5H4.5L8.69629 6.02148ZM12.0742 14.5H13.8838L4.00391 1.5H2.03613L12.0742 14.5Z" fill="black"/>
                  </svg>
                </div>
                {/* Instagram */}
                <div className={styles.socialIcon}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                    <path d="M11 0.5C13.2091 0.5 15 2.29086 15 4.5V11.5C15 13.64 13.3194 15.3879 11.2061 15.4951L11 15.5H4L3.79395 15.4951C1.7488 15.3913 0.108652 13.7512 0.00488281 11.7061L0 11.5V4.5C0 2.29086 1.79086 0.5 4 0.5H11ZM4 1.5C2.34315 1.5 1 2.84315 1 4.5V11.5C1 13.1569 2.34315 14.5 4 14.5H11C12.6569 14.5 14 13.1569 14 11.5V4.5C14 2.84315 12.6569 1.5 11 1.5H4ZM7.5 4.25C9.57107 4.25 11.25 5.92893 11.25 8C11.25 10.0711 9.57107 11.75 7.5 11.75C5.42893 11.75 3.75 10.0711 3.75 8C3.75 5.92893 5.42893 4.25 7.5 4.25ZM7.5 5.25C5.98122 5.25 4.75 6.48122 4.75 8C4.75 9.51878 5.98122 10.75 7.5 10.75C9.01878 10.75 10.25 9.51878 10.25 8C10.25 6.48122 9.01878 5.25 7.5 5.25ZM11.5645 3C12.082 3.00021 12.502 3.41986 12.502 3.9375C12.5017 4.45496 12.0819 4.87479 11.5645 4.875C11.0468 4.875 10.6272 4.45509 10.627 3.9375C10.627 3.41973 11.0467 3 11.5645 3Z" fill="black"/>
                  </svg>
                </div>
                {/* TikTok */}
                <div className={styles.socialIcon}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
                    <path d="M9.42033 0.5H6.89238V10.7174C6.89238 11.9348 5.92012 12.9348 4.71016 12.9348C3.50021 12.9348 2.52793 11.9348 2.52793 10.7174C2.52793 9.52175 3.47861 8.54346 4.64536 8.5V5.93479C2.0742 5.97825 0 8.08696 0 10.7174C0 13.3696 2.11741 15.5 4.73178 15.5C7.34611 15.5 9.46352 13.3478 9.46352 10.7174V5.47825C10.4142 6.17392 11.5809 6.58696 12.8125 6.60871V4.04348C10.9112 3.97826 9.42033 2.41304 9.42033 0.5Z" fill="#0A0B0C"/>
                  </svg>
                </div>
                {/* LinkedIn */}
                <div className={styles.socialIcon}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                    <path d="M13.8896 0.5H1.10742C0.495117 0.5 0 0.983398 0 1.58105V14.416C0 15.0137 0.495117 15.5 1.10742 15.5H13.8896C14.502 15.5 15 15.0137 15 14.4189V1.58105C15 0.983398 14.502 0.5 13.8896 0.5ZM4.4502 13.2822H2.22363V6.12207H4.4502V13.2822ZM3.33691 5.14648C2.62207 5.14648 2.04492 4.56934 2.04492 3.85742C2.04492 3.14551 2.62207 2.56836 3.33691 2.56836C4.04883 2.56836 4.62598 3.14551 4.62598 3.85742C4.62598 4.56641 4.04883 5.14648 3.33691 5.14648ZM12.7822 13.2822H10.5586V9.80176C10.5586 8.97266 10.5439 7.90332 9.40137 7.90332C8.24414 7.90332 8.06836 8.80859 8.06836 9.74316V13.2822H5.84766V6.12207H7.98047V7.10059H8.00977C8.30566 6.53809 9.03223 5.94336 10.1133 5.94336C12.3662 5.94336 12.7822 7.42578 12.7822 9.35352V13.2822Z" fill="#0A0B0C"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
      
      
    </div>
  );
};

export default Footer;
